import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.as{justify-content:center;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.b1{text-align:center;}.ssr-plugin'
import '.b2{margin:6rem auto 3rem;}.ssr-plugin'
import { styled } from 'inlines'
import { PageLayout } from '../layout/PageLayout'
import notFoundImage from '@app/assets/images/error/not-found.svg'
import { Image } from '@app/components/core/image/Image'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import useMediaQuery from '@app/util/useMediaQuery'
import { useTranslations } from '@i18n/useLanguage'
import { PageSeo } from '@app/components/core/seo/PageSeo'
import { useReportHttpStatus } from '@app/util/hooks/useReportHttpStatus'

export const NotFoundPage = () => {
  useReportHttpStatus(404)
  const isMobile = useMediaQuery()
  const t = useTranslations().app.error
  const contentStyle = isMobile
    ? { minWidth: '17rem', gap: '1rem' }
    : { maxWidth: '40rem', gap: '2.5rem' }
  const imageStyle = { width: isMobile ? '17rem' : 'auto' }
  const BodyText = isMobile ? Text.Medium : Text.Large

  return (
    <PageLayout>
      <PageSeo
        pageTitle={t.notFoundTitle}
        description={t.notFoundMessage}
        noindex
      />
      <div className="a b as t b1 b2"
      >
        <styled.div className="a b t"
          style={{
            ...contentStyle,
          }}
        >
          <Image src={notFoundImage} alt={t.imageAlt} style={imageStyle} />
          <Title.Page styledAsLevel={2} style={{ marginBottom: 0 }}>
            {t.notFoundTitle}
          </Title.Page>
          <BodyText>{t.notFoundMessage}</BodyText>
        </styled.div>
      </div>
    </PageLayout>
  )
}
